module.exports = __webpack_public_path__ + "media/assets/images/sign-girl-student-bdbb3e139cf56fa5bfd9e65ff57710cb.png";